/**
 * De hulp van Socrates in de tweede fase: de vier hulpvormen en de bronnen.
 *
 * verhelder en vereenvoudig werken op wat de leerling in het gesprek heeft
 * geselecteerd; hints en kritiek op wat er in het formulier staat. De
 * antwoorden staan in het scherm en niet in de stap Argumenten, zodat ze
 * blijven staan als de leerlingen even terug naar de chat gaan.
 *
 * Een antwoord: { soort, label, overTekst, antwoord } of, voor de bronnen,
 * { soort: 'bronnen', label, bronnen: [...] }. Het nieuwste staat vooraan.
 */
import { useState } from 'react';

export const HULP_LABELS = {
  verhelder: 'Uitleg',
  vereenvoudig: 'Korter gezegd',
  hints: 'Tip',
  kritiek: 'Vragen bij je argument',
};

function geselecteerdeTekst() {
  try { return (window.getSelection()?.toString() || '').trim(); }
  catch (err) { return ''; }
}

export function useHulp({ api, discussion, argumenten }) {
  const [antwoorden, setAntwoorden] = useState([]);
  const [bezig, setBezig] = useState(null); // de soort die onderweg is
  const [melding, setMelding] = useState('');

  const vraag = async (soort, extra = {}) => {
    setMelding('');
    let tekst = extra.tekst || '';
    if ((soort === 'verhelder' || soort === 'vereenvoudig') && !tekst) {
      tekst = geselecteerdeTekst();
      if (!tekst) {
        setMelding('Selecteer eerst een stukje tekst in het gesprek hieronder.');
        return;
      }
    }
    setBezig(soort);
    try {
      const data = await api.vraagHulp(discussion.discussion_id, {
        soort, tekst, kant: extra.kant,
        voor: argumenten.voor.filter(a => a.trim()),
        tegen: argumenten.tegen.filter(a => a.trim()),
      });
      if (data.success) {
        setAntwoorden(prev => [{ soort, label: HULP_LABELS[soort] || 'Socrates', overTekst: tekst, antwoord: data.data.antwoord }, ...prev]);
      } else {
        setMelding(data.detail || 'Dat lukte niet. Probeer het nog eens.');
      }
    } catch (err) {
      setMelding('Geen verbinding met Socrates. Probeer het nog eens.');
    } finally {
      setBezig(null);
    }
  };

  const vraagBronnen = async () => {
    setMelding('');
    setBezig('bronnen');
    try {
      const data = await api.haalBronnen(discussion.discussion_id);
      if (data.success) {
        setAntwoorden(prev => [{ soort: 'bronnen', label: 'De bronnen', bronnen: data.data }, ...prev]);
      } else {
        setMelding('De bronnen konden niet worden opgehaald.');
      }
    } catch (err) {
      setMelding('Geen verbinding. Probeer het nog eens.');
    } finally {
      setBezig(null);
    }
  };

  return { antwoorden, bezig, melding, vraag, vraagBronnen };
}
